import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rc2002',
    ecrans: ['00-2']
});

